import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79017614"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onmouseover", "onmouseleave"]
const _hoisted_2 = { class: "index" }
const _hoisted_3 = ["src"]

import { ref, watchEffect } from 'vue';
import RemoveIcon from './icons/RemoveIcon.vue';

interface IProps {
    imageFile: any;
    index: number;
    disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomImageUpload',
  props: {
    imageFile: {},
    index: {},
    disabled: { type: Boolean }
  },
  emits: ['removeFile'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const imageUrl = ref();

const showRemove = ref<boolean>(false);
const typeImage = ref<string>('');
const pathImage = ref<string>('');


watchEffect(
    () => {
        if (typeof props.imageFile == 'object') {
            imageUrl.value = URL.createObjectURL(props.imageFile);
            typeImage.value = props.imageFile.type;
            pathImage.value = props.imageFile.name;
        } else {
            imageUrl.value = props.imageFile;
            pathImage.value = props.imageFile;
            const type = props.imageFile.split('.').at(-1)
            typeImage.value = `image/${type}`;
        }
    }
);


return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "image",
    style: _normalizeStyle({ cursor: !props.disabled ? 'grab' : 'default' }),
    onmouseover: () => showRemove.value = true,
    onmouseleave: () => showRemove.value = false,
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.index + 1), 1),
    _createVNode(_component_v_tooltip, {
      text: "Excluir foto",
      location: "top"
    }, {
      activator: _withCtx(({ props }) => [
        (showRemove.value && !_ctx.disabled)
          ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, props, {
              class: "btnRemove",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('removeFile', _ctx.index)), ["stop"]))
            }), [
              _createVNode(RemoveIcon)
            ], 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (props.imageFile != null)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: imageUrl.value
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true)
  ], 12, _hoisted_1))
}
}

})